<div class="row">
  <div labelTextInput class="col-sm-4 bloccodati"
    [typeLabel]="'text'" [labelInput]="'Id REF'"
    [valueInput]="ctxBodyFascicolo.fascicolo.idREF ? ctxBodyFascicolo.fascicolo.idREF : ''"></div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
